// A note the person wrote in the Notebook. Props and callbacks only.
import React from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import DisabledReason from '../../system/DisabledReason'

export interface NotebookNoteCellProps {
  text: string
  /** Send changes has put this note in the message box once already. */
  sent?: boolean
  readOnlyReason?: string
  onChange: (text: string) => void
  onDelete: () => void
}

export const NotebookNoteCell: React.FC<NotebookNoteCellProps> = ({ text, sent, readOnlyReason, onChange, onDelete }) => (
  <Box>
    <TextField
      fullWidth
      multiline
      minRows={2}
      size="small"
      placeholder="Write a note"
      value={text}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{ htmlInput: { readOnly: !!readOnlyReason, maxLength: 4000, 'aria-label': 'Note', 'data-testid': 'notebook-note-text' } }}
    />
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, mt: 0.5 }}>
      {sent && (
        <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }} data-testid="notebook-note-sent">
          Sent to the agent. Change it to send it again.
        </Typography>
      )}
      <DisabledReason reason={readOnlyReason}>
        <Button size="small" color="info" onClick={onDelete} data-testid="notebook-note-delete">
          Delete note
        </Button>
      </DisabledReason>
    </Box>
  </Box>
)

export default NotebookNoteCell
